import { createAppTheme } from '@shared/ui';

export const theme = createAppTheme();
